import { render, staticRenderFns } from "./ExhibitionLogos.vue?vue&type=template&id=ae2c4046&scoped=true&"
import script from "./ExhibitionLogos.vue?vue&type=script&lang=js&"
export * from "./ExhibitionLogos.vue?vue&type=script&lang=js&"
import style0 from "./ExhibitionLogos.vue?vue&type=style&index=0&id=ae2c4046&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae2c4046",
  null
  
)

export default component.exports